import { Route, Routes } from 'react-router-dom';
import Challenges from '../Challenges/Challenges';
import { AddWordToCustomList } from '../CustomLists/AddWordToCustomList/AddWordToCustomList';
import { CreateCustomList } from '../CustomLists/CreateCustomList/CreateCustomList';
import { ImportWords } from '../CustomLists/ImportWords/ImportWords';
import Discover from '../Discover/Discover';
import { DiscoverPage } from '../Discover/DiscoverPage/DiscoverPage';
import { WordListPage } from '../Discover/WordListPage/WordListPage';
import HomePage from '../Home/HomePage';
import { Chat } from '../Home/LexiSection/Chat/Chat';
import ListView from '../Home/ProgressHeader/ListView/ListView';
import Learn from '../Learn/Learn';
import { LessonPage } from '../Lessons/LessonPage/LessonPage';
import Lessons from '../Lessons/Lessons';
import { Membership } from '../Membership/Mambership';
import { Comparison } from '../Membership/Pro/Comparison/Comparison';
import { EarnHeart } from '../Membership/Pro/EarnHeart/EarnHeart';
import { ShowAds } from '../Membership/Pro/ShowAds/ShowAds';
import { AddFriend } from '../Progress/Friends/AddFriend/AddFriend';
import Progress from '../Progress/Progress';
import ScenarioChat from '../Scenario/ScenarioChat/ScenarioChat';
import ScenarioDescription from '../Scenario/ScenarioDescription/ScenarioDescription';
import ScenarioPage from '../Scenario/ScenarioPage/ScenarioPage';
import ScenarioSubPage from '../Scenario/ScenarioSubPage/ScenarioSubPage';
import { Search } from '../Search/Search';
import { LogOut } from './LogOut';
const RoutesPage = () => {
    return (
        <Routes>
            {/* <Route index element={<Navigate to="/wordlists" replace />} /> */}
            <Route index element={<HomePage />} />
            <Route path='/' element={<HomePage />} />
            <Route path='lessons' element={<Lessons />} />
            <Route path='wordlists' element={<Discover />} />
            <Route path='learn' element={<Learn />} />
            <Route path='progress' element={<Progress />} />
            <Route path='add-friend' element={<AddFriend />} />
            <Route path='wordlists/discover' element={<DiscoverPage />} />
            <Route path='wordlists/wordlist' element={<WordListPage />} />
            <Route path='lessons/lesson' element={<LessonPage />} />
            <Route path='search' element={<Search />} />
            <Route path='logout' element={<LogOut />} />
            <Route path='wordlists/create-new' element={<CreateCustomList />} />
            <Route path='wordlists/add-words' element={<AddWordToCustomList />} />
            <Route path='wordlists/import-words' element={<ImportWords />} />
            <Route path='challenges' element={<Challenges />} />
            <Route path='scenario' element={<ScenarioPage />} />
            <Route path='scenario/category' element={<ScenarioSubPage />} />
            <Route path='scenario/description' element={<ScenarioDescription />} />
            <Route path='scenario/chat' element={<ScenarioChat />} />
            <Route path='home/listview' element={<ListView />} />
            <Route path='membership' element={<Membership />} />
            <Route path='show-ads' element={<ShowAds />} />
            <Route path='comparison' element={<Comparison />} />
            <Route path='earn-heart' element={<EarnHeart />} />
            <Route path='chat' element={<Chat />} />
            <Route path='*' element={<HomePage />} />
        </Routes>
    );
}

export { RoutesPage };

